import React, { useState, useRef, useEffect } from 'react';
import { FileText, ChevronDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const WorkshopExportMenu = ({
    onExportPdfFr,
    onExportPdfEn,
    onExportDocxFr,
    onExportDocxEn,
    onExportCsvFr,
    onExportCsvEn,
    isExporting = false,
}) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Handle click outside to close
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="relative" ref={dropdownRef}>
            <button
                onClick={() => setIsOpen(!isOpen)}
                disabled={isExporting}
                className={`flex items-center px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition duration-200 shadow-sm font-medium text-sm ${isExporting ? 'opacity-70 cursor-not-allowed' : ''}`}
            >
                <FileText size={16} className="mr-2" />
                {isExporting ? t('common.exporting', 'Export en cours...') : t('common.export', 'Exporter')}
                <ChevronDown size={14} className={`ml-2 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
            </button>

            {isOpen && !isExporting && (
                <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-xl border border-slate-200 z-50 py-1 overflow-hidden">
                    {/* PDF Section — FIRST */}
                    <div className="px-4 py-2 text-xs font-semibold text-slate-500 bg-slate-50 border-b border-slate-100 uppercase tracking-wider flex items-center">
                        <FileText size={12} className="mr-2" />
                        PDF
                    </div>

                    <button
                        onClick={() => { onExportPdfFr?.(); setIsOpen(false); }}
                        className="w-full flex items-center px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 transition duration-150"
                    >
                        <span className="mr-3">🇫🇷</span>
                        Français (PDF)
                    </button>

                    <button
                        onClick={() => { onExportPdfEn?.(); setIsOpen(false); }}
                        className="w-full flex items-center px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 transition duration-150"
                    >
                        <span className="mr-3">🇺🇸</span>
                        English (PDF)
                    </button>

                    {/* Word Section — SECOND */}
                    <div className="px-4 py-2 text-xs font-semibold text-slate-500 bg-slate-50 border-y border-slate-100 uppercase tracking-wider flex items-center mt-1">
                        <FileText size={12} className="mr-2" />
                        Word
                    </div>

                    <button
                        onClick={() => { onExportDocxFr?.(); setIsOpen(false); }}
                        className="w-full flex items-center px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 transition duration-150"
                    >
                        <span className="mr-3">🇫🇷</span>
                        Français (Word)
                    </button>

                    <button
                        onClick={() => { onExportDocxEn?.(); setIsOpen(false); }}
                        className="w-full flex items-center px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 transition duration-150"
                    >
                        <span className="mr-3">🇺🇸</span>
                        English (Word)
                    </button>

                    {/* CSV Section — THIRD */}
                    {(onExportCsvFr || onExportCsvEn) && (
                        <>
                            <div className="px-4 py-2 text-xs font-semibold text-slate-500 bg-slate-50 border-y border-slate-100 uppercase tracking-wider flex items-center mt-1">
                                <FileText size={12} className="mr-2" />
                                CSV / Excel
                            </div>

                            {onExportCsvFr && (
                                <button
                                    onClick={() => { onExportCsvFr?.(); setIsOpen(false); }}
                                    className="w-full flex items-center px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 transition duration-150"
                                >
                                    <span className="mr-3">🇫🇷</span>
                                    Français (CSV)
                                </button>
                            )}

                            {onExportCsvEn && (
                                <button
                                    onClick={() => { onExportCsvEn?.(); setIsOpen(false); }}
                                    className="w-full flex items-center px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 transition duration-150"
                                >
                                    <span className="mr-3">🇺🇸</span>
                                    English (CSV)
                                </button>
                            )}
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default WorkshopExportMenu;
